import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined,
  ten: undefined,
  ma_sp: undefined,
  mo_ta_ngan: undefined,
  mo_ta: undefined,
  gia_niem_yet: undefined,
  dai_ly_ban: false,
  phu_kien: false,
  san_pham_cha_ids: [],
  thoi_diem_tao: undefined,
  loai: undefined,
  goi_dich_vu_id: undefined,
  don_vi: undefined,
  hieu_luc: undefined,
};

model.dieuKien = [];
model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      ma_sp: "",
      ten: "",
      loai: "",
      phu_kien: "",
      dai_ly_ban: undefined,
      hieu_luc: undefined,
    },
    valid: {
      ma_sp: [],
      ten: [],
      loai: [],
    },
    operator: {
      ma_sp: ":regex_i:",
      ten: ":regex_i:",
      loai: ":regex_i:",
    },
  },
};

export default model;
